<template>
    <div>        
        <list :label="$t('pharmacies')" v-bind:refresh="this.refresh" table='pharmacies' v-on:childMessage="onMessageFromListReceived" initialSortBy="name" :initialSortDesc="false"></list>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">
                        <div v-if="field.value !== 'id' && field.value !== 'actions'">
                            <v-text-field v-model="field.model" v-bind:label="field.text"/>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t('save')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t('cancel')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: ""
        };
    },

    props: [],

    mixins: [Utils],

    created()
    {
    },

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new pharmacy");
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {                    
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update pharmacy");
                this.fields = JSON.parse(JSON.stringify(message.header));
                for (let field of this.fields)
                {                    
                    field.model = message.item[field.value]
                }

                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("pharmacies", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t("action not possible"));

                })
                .catch((e) =>
                {
                    alert (self.$t("action not possible"));
                });
            }
        },
        cancel ()
        {
            this.showDialog = "";
            this.fields = [];
        },
        save ()
        {
            const self = this;
            this.text = "";
            for (let field of this.fields)
            {                
                if (field.text === "Name")
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter name");
                        return;
                    }
                    else
                        break;
            }
            Api.saveRecord("pharmacies", this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    self.refresh += 1;
                }
                else
                    self.text = self.$t("action not possible");

            })
            .catch((e) =>
            {
                self.text = self.$t("action not possible");
            });
        }
    }
};
</script>